import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

/**
 * Hook para obtener el logo de marca dinámico.
 * El logo se recarga automáticamente cuando se actualiza.
 */
export const useBrandLogo = () => {
  const [logoUrl, setLogoUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [timestamp, setTimestamp] = useState(Date.now());

  const fetchLogo = useCallback(async () => {
    try {
      setLoading(true);
      // Verificar si el endpoint existe
      const response = await axios.get(`${API_URL}/brand/logo`);
      if (response.data?.logo_url) {
        // La versión (fecha de actualización) permite al navegador guardar el logo en caché
        const version = response.data.updated_at || timestamp;
        setLogoUrl(`${API_URL}/brand/logo/image?v=${encodeURIComponent(version)}`);
      } else {
        setLogoUrl(null);
      }
      setError(null);
    } catch (err) {
      console.error('Error fetching brand logo:', err);
      setError(err);
      setLogoUrl(null);
    } finally {
      setLoading(false);
    }
  }, [timestamp]);

  useEffect(() => {
    fetchLogo();
  }, [fetchLogo]);

  // Función para refrescar el logo manualmente
  const refreshLogo = useCallback(() => {
    setTimestamp(Date.now());
  }, []);

  return { logoUrl, loading, error, refreshLogo };
};

export default useBrandLogo;
